<script setup>
const { isWidget } = useWidgetSettings()
const { isPeloton } = useEnterpriseClient()
</script>

<template>
  <div class="mobile-page-header items-center justify-between px-4 text-[--theme-color-underlay-text] lt-sm:flex sm:hidden">
    <div class="title flex items-center gap-2 text-lg fw-600">
      <AppNavMenuItemsProvider v-slot="{ activeItem }">
        <DSIcon
          :icon="activeItem?.icon"
          size="24"
        /> {{ activeItem?.label }}
      </AppNavMenuItemsProvider>
    </div>
    <AppNavMenuMobileToggleButton
      v-if="isWidget && !isPeloton"
      size="32"
    />
  </div>
</template>
